import DOMPurify from 'dompurify';
import { LocalHistoryEntry } from './types';

function removeFromDom(element: string) {
    const myNode = document.getElementById(element);
    if (!myNode || !myNode.lastChild) return;

    while (myNode.firstChild) {
        myNode.removeChild(myNode.lastChild);
    }
}

function getLocalHistory(browserStorageKey: string): LocalHistoryEntry[] {
    if (typeof Storage === 'undefined') return [];

    const searchHistory: string | null = localStorage.getItem(browserStorageKey);

    if (!searchHistory) return [];

    const parsedSearchHistory: string[] = JSON.parse(searchHistory);
    return parsedSearchHistory
        .filter(item => item)
        .map((item, index: number) => ({ id: index, value: item }));
}

function saveLocalHistory(keyword: string, storageKey: string, maxSuggestion: number) {
    if (typeof Storage === 'undefined') return;

    const searchHistory = localStorage.getItem(storageKey);
    const newHistory = [];

    if (searchHistory) {
        const parsedSearchHistory: string[] = JSON.parse(searchHistory);
        parsedSearchHistory.forEach((entry, index: number) => {
            if (index > maxSuggestion - 2) return;
            const newEntry = entry.trim().toLowerCase();
            if (keyword != entry) newHistory.push(newEntry);
        });

        newHistory.unshift(keyword);
    } else {
        newHistory.push(keyword);
    }

    localStorage.setItem(storageKey, JSON.stringify(newHistory));
}

function sendGaSearchEvent(cleanKeyword: string) {
    window.dataLayer.push({
        event: 'GA4 - Generic Event',
        event_name: 'search',
        search_term: cleanKeyword,
    });
}

function sanitizeString(word: string): string {
    return DOMPurify.sanitize(word.trim().toLowerCase());
}

const keys = Object.freeze({
    ESC: "Escape",
    DOWN: "ArrowDown",
    UP: "ArrowUp",
    TAB: "Tab",
});

const elementValues = Object.freeze({
    VALUE: 'value',
    TEXTCONTENT: 'textContent',
    INNERTEXT: 'innerText',
});

export { removeFromDom, getLocalHistory, saveLocalHistory, sanitizeString, sendGaSearchEvent, elementValues, keys };
